module.exports = __webpack_public_path__ + "static/media/trekspresso-5.a44b772d.jpg";